import React from 'react';

export default function MiscellaneousPoint({ point }) {
  return (
    <div className="flex h-full w-full flex-1 items-center justify-center rounded-lg bg-v5-green-500 p-4 text-center">
      {point.content}
    </div>
  );
}
